import { isElementNode, isTag } from 'anodum';
import { IMAGE_SELECTOR } from '../../hdrm/constants/image-selector';
import { IMAGE_TAG } from '../constants/editable-elements';

const isMediaElement = (element) => {
  if (!isElementNode(element)) return false;

  return (
    (isTag(element, IMAGE_SELECTOR) && Boolean(element.querySelector(IMAGE_TAG))) ||
    (isTag(element, IMAGE_TAG) && Boolean(element.src))
  );
};

export default isMediaElement;
